import React from 'react';
import styles from './nav-panel.module.scss';
import { Link } from "gatsby"

class NavTab extends React.Component {
  render() {
    return (
      <div className={styles.navPanelMenuItem}>
        <Link {...this.props} className={styles.link} getProps={this.getProps.bind(this)}>
          {this.props.title}
        </Link>
      </div>
    );
  }

  // Control what link is considered active
  // This is part of the Link API - see https://reach.tech/router/api/Link
  getProps({ isCurrent, href }) {
    if (isCurrent || this.props.forceActive ) {
      return { className: styles.activeLink };
    } else {
      return null;
    }
  }
}
export default NavTab;